import { Component, OnInit } from '@angular/core';

// Modales
import { AlertasModales } from '../../../helpers/alertasModales';

// Servicios
import { RutasService } from '../../../services/rutas.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

const ID_PAGINA = 30;

@Component({
  selector: 'app-lista-rutas',
  templateUrl: './lista-rutas.component.html',
  styleUrls: ['./lista-rutas.component.css']
})
export class ListaRutasComponent implements OnInit {
  listaRutas: any[] = [];
  loaded = false;
  datosEmpleado: any;
  page = 1;
  limit = 50;
  offset = 0;
  size = 0;
  busqueda = '';
  estadoSeleccionado = '1';
  loading = false;


  constructor(
    private rutasService: RutasService,
    private modals: AlertasModales,
    private empleadoService: EmpleadosServicio,
    private router: Router,
    private route: ActivatedRoute,
    ) {
    if (empleadoService.datosEmpleado.tipo_empleado !== 3 && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }
    this.datosEmpleado = this.empleadoService.datosEmpleado;
  }

  ngOnInit() {
    this.verificarQueryString();
  }

  private initRutas(): void {
    this.rutasService.cargarTodasLasRutas(
      false,
      this.limit,
      this.offset,
      this.busqueda,
      this.estadoSeleccionado
    ).subscribe(res => {
      this.listaRutas = res.rutas
      this.size = res.total_items;
      this.loaded = true;
      this.loading = false;
    });
  }

  // Mostrar la modal ng bootstrap para la lista de empleados
  listaEmpleados(ruta) {
    this.modals.listaEmpleadosNgbModal(ruta);
  }

  editarRuta(ruta) {
    this.modals.editarRutaNgbModal(ruta).then(res => {
      if (res) {
        this.initRutas();
        this.modals.correctoModalJquery('Ruta editada con éxito', 'green', 'modern', 'fa fa-upload fa-map');
      }
    });
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {
        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = this.limit * (this.page - 1);
        }
        if (params.busqueda) {
          this.busqueda = params.busqueda;
        }
        if (params.limite && !isNaN(params.limite)) {
          this.limit = params.limite;
        }
        if (params.estado) {
          this.estadoSeleccionado = params.estado;
        }
        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = this.limit * (this.page - 1);
        }

        this.initRutas();
      }
    });
  }

  public filtrar() {
    this.page = 1;
    this.offset = 0;
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['busqueda'] = this.busqueda;
    queryParams['limite'] = this.limit;
    queryParams['estado'] = this.estadoSeleccionado;
 
    this.router.navigate(['./lista/rutas'], { queryParams: queryParams });
  }

  public loadPage(page: number) {
    this.page = page;
    this.offset = this.limit * (this.page - 1);
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['page'] = page;
    this.router.navigate(['./lista/rutas'], { queryParams: queryParams });
    this.initRutas();
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/rutas/lista/lista-rutas.component.ts